module.exports = __webpack_public_path__ + "media/images/post/icon_sns_facebook-967c657ad9c38556fe0c1237ee8cf635.svg";